import http from "./httpService";
import { apiUrl } from ".././config.json";

export const getBookingsToShow = (data) => {
  // to get available reschdule
  const apiEndPoint = `${apiUrl}/BookingReschedule/RescheduleDetails`;
  return http.post(`${apiEndPoint}`, data);
};
export const GetRescheduleCharges = (data) => {
  // to get reschedule charges
  const apiEndPoint = `${apiUrl}/BookingReschedule/RescheduleDetails`;
  return http.post(`${apiEndPoint}`, data);
};
export const getGstData = (data) => {
  //to get gst
  const apiEndPoint = `${apiUrl}/TaxMstr/IdDate`;
  return http.post(`${apiEndPoint}`, data);
};
export const getRescheduleBoat = (data) => {
  // to get booked boat for reschdule
  const apiEndPoint = `${apiUrl}/BookingReschedule/RescheduleDetails`;
  return http.post(`${apiEndPoint}`, data);
};

export const getAvailableBoatSlotTime = (data) => {
  // to get availableBoatSlotTime
  const apiEndPoint = `${apiUrl}/GetAvailableBoatSlotTime`;
  return http.post(`${apiEndPoint}`, data);
};

export const rescheduleBeforeTransaction = (data) => {
  //before Transcation
  const apiEndPoint = `${apiUrl}/PublicOnlineBoatBookingBfrTran`;
  return http.post(`${apiEndPoint}`, data);
};
export const CheckWDAndWEBoatCharge = (data) => {
  // to check reschedule available on selected date
  const apiEndPoint = `${apiUrl}/BookingReschedule/RescheduleDetails`;
  return http.post(`${apiEndPoint}`, data);
};
export const getBookedOtherService = (data) => {
  // to check reschedule available on selected date
  const apiEndPoint = `${apiUrl}/BookingReschedule/RescheduleDetails`;
  return http.post(`${apiEndPoint}`, data);
};

export const getRescheduleHistory = (data) => {
  //to get reschedule history
  const apiEndPoint = `${apiUrl}/CommonAPIMethod`;
  return http.post(`${apiEndPoint}`, data);
};

// export const GetCancellationReasons = (data) => {
//   const apiEndPoint = `${apiUrl}/ConfigMstrList/Type`;
//   return http.post(`${apiEndPoint}`, data);
// };
// export const BookingReschedule = (data) => {
//   const apiEndPoint = `${apiUrl}/BookingReschedule`;
//   return http.post(`${apiEndPoint}`, data);
// };
// export const bookingAfterTransaction = (data) => {
//   const apiEndPoint = `${apiUrl}/PublicOnlineBoatBookingAftrTran`;
//   return http.post(`${apiEndPoint}`, data);
// };
// export const BoatPrintTicket = (data) => {
//   const apiEndPoint = `${apiUrl}/CommonAPIMethod`;
//   return http.post(`${apiEndPoint}`, data);
// };
